var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row gutter-sm q-mb-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c(
              "q-field",
              { attrs: { count: 256 } },
              [
                _c("q-input", {
                  ref: "title",
                  attrs: {
                    "float-label": _vm.$t("title"),
                    error: _vm.$v.title.$error,
                    disable: !_vm.manage_trails
                  },
                  on: { input: _vm.$v.title.$touch },
                  model: {
                    value: _vm.title,
                    callback: function($$v) {
                      _vm.title = $$v
                    },
                    expression: "title"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c(
              "q-field",
              { attrs: { count: 1024 } },
              [
                _c("q-input", {
                  ref: "description",
                  attrs: {
                    "float-label": _vm.$t("introduction"),
                    rows: "1",
                    "max-height": 100,
                    type: "textarea",
                    error: _vm.$v.description.$error,
                    disable: !_vm.manage_trails
                  },
                  on: { input: _vm.$v.description.$touch },
                  model: {
                    value: _vm.description,
                    callback: function($$v) {
                      _vm.description = $$v
                    },
                    expression: "description"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("q-select", {
              attrs: {
                options: _vm.selected_parent_trail,
                "float-label": _vm.$t("requirement"),
                chips: "",
                clearable: "",
                readonly: !_vm.selected_parent_trail,
                disable: !_vm.manage_trails
              },
              on: { clear: _vm.clearSelection },
              nativeOn: {
                click: function($event) {
                  return _vm.showTrailParents.apply(null, arguments)
                },
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.showTrailParents.apply(null, arguments)
                }
              },
              model: {
                value: _vm.trail_parent,
                callback: function($$v) {
                  _vm.trail_parent = $$v
                },
                expression: "trail_parent"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("q-datetime", {
              attrs: {
                "float-label": _vm.$t("availability_date"),
                type: "date",
                format: "DD/MM/YYYY",
                clearable: ""
              },
              model: {
                value: _vm.availability_date,
                callback: function($$v) {
                  _vm.availability_date = $$v
                },
                expression: "availability_date"
              }
            })
          ],
          1
        ),
        _vm.showCategories
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                _c("q-select", {
                  ref: "category",
                  attrs: {
                    filter: "",
                    "autofocus-filter": "",
                    "float-label": _vm.$t("categories"),
                    options: _vm.optionCategories,
                    error: _vm.$v.category.$error
                  },
                  on: { input: _vm.$v.category.$touch },
                  model: {
                    value: _vm.category,
                    callback: function($$v) {
                      _vm.category = $$v
                    },
                    expression: "category"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("q-select", {
              ref: "tag",
              attrs: {
                options: _vm.optionTags,
                "float-label": _vm.$t("tags"),
                error: _vm.$v.tag.$error,
                multiple: "",
                chips: "",
                filter: "",
                "autofocus-filter": "",
                disable: !_vm.manage_trails
              },
              on: { input: _vm.$v.tag.$touch },
              model: {
                value: _vm.tag,
                callback: function($$v) {
                  _vm.tag = $$v
                },
                expression: "tag"
              }
            })
          ],
          1
        ),
        _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
          _c("div", { staticClass: "row gutter-sm" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c("p", { staticClass: "caption" }, [
                  _vm._v(_vm._s(_vm.$t("image")))
                ]),
                _c("uploader", {
                  attrs: {
                    content_type: "images",
                    multiple: false,
                    cropper: true,
                    disable: !_vm.manage_trails
                  },
                  on: { fileUploaded: _vm.imageUploaded }
                }),
                _vm.image_url
                  ? _c(
                      "p",
                      { staticClass: "q-mt-md file-url" },
                      [
                        _c("q-icon", {
                          attrs: { name: "fal fa-check", color: "positive" }
                        }),
                        _c(
                          "a",
                          { attrs: { href: _vm.image_url, target: "_blank" } },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$truncateLink(_vm.image_url))
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
              _c(
                "p",
                { staticClass: "caption" },
                [
                  _vm._v(
                    "\n\t\t\t\t\t\t" +
                      _vm._s(_vm.$t("alt_image")) +
                      "\n\t\t\t\t\t\t"
                  ),
                  _c(
                    "q-icon",
                    {
                      staticClass: "q-ml-sm q-pb-sm",
                      attrs: {
                        name: "fal fa-question-circle",
                        size: "1.5rem",
                        color: "grey"
                      }
                    },
                    [
                      _c(
                        "q-tooltip",
                        {
                          staticClass: "custom-tooltip",
                          attrs: { anchor: "top left", self: "bottom right" }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t" +
                              _vm._s(_vm.$t("alt_image_information_helper")) +
                              "\n\t\t\t\t\t\t\t"
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex justify-between" },
                [
                  _vm._l(_vm.languages, function(lang) {
                    return [
                      lang.code === "pt-br"
                        ? _c(
                            "q-field",
                            { key: lang.id, attrs: { count: 170 } },
                            [
                              _c("q-input", {
                                ref: "language_br",
                                refInFor: true,
                                attrs: {
                                  "float-label": _vm.$t("" + lang.name),
                                  error: _vm.$v.language_br.$error
                                },
                                on: { input: _vm.$v.language_br.$touch },
                                model: {
                                  value: _vm.language_br,
                                  callback: function($$v) {
                                    _vm.language_br = $$v
                                  },
                                  expression: "language_br"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      lang.code === "en-us"
                        ? _c(
                            "q-field",
                            { key: lang.id, attrs: { count: 170 } },
                            [
                              _c("q-input", {
                                ref: "language_us",
                                refInFor: true,
                                attrs: {
                                  "float-label": _vm.$t("" + lang.name),
                                  error: _vm.$v.language_us.$error
                                },
                                on: { input: _vm.$v.language_us.$touch },
                                model: {
                                  value: _vm.language_us,
                                  callback: function($$v) {
                                    _vm.language_us = $$v
                                  },
                                  expression: "language_us"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      lang.code === "es-es"
                        ? _c(
                            "q-field",
                            { key: lang.id, attrs: { count: 170 } },
                            [
                              _c("q-input", {
                                ref: "language_es",
                                refInFor: true,
                                attrs: {
                                  "float-label": _vm.$t("" + lang.name),
                                  error: _vm.$v.language_es.$error
                                },
                                on: { input: _vm.$v.language_es.$touch },
                                model: {
                                  value: _vm.language_es,
                                  callback: function($$v) {
                                    _vm.language_es = $$v
                                  },
                                  expression: "language_es"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      lang.code === "fr-fr"
                        ? _c(
                            "q-field",
                            { key: lang.id, attrs: { count: 170 } },
                            [
                              _c("q-input", {
                                ref: "language_fr",
                                refInFor: true,
                                attrs: {
                                  "float-label": _vm.$t("" + lang.name),
                                  error: _vm.$v.language_fr.$error
                                },
                                on: { input: _vm.$v.language_fr.$touch },
                                model: {
                                  value: _vm.language_fr,
                                  callback: function($$v) {
                                    _vm.language_fr = $$v
                                  },
                                  expression: "language_fr"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  })
                ],
                2
              )
            ])
          ])
        ])
      ]),
      _c(
        "q-tabs",
        {
          staticClass: "shadow-1",
          attrs: { color: "secondary" },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "permissions",
              icon: "fal fa-clipboard-list-check",
              label: _vm.$t("permissions"),
              disable: !_vm.manage_trails
            },
            slot: "title"
          }),
          _c(
            "q-tab-pane",
            { staticClass: "q-px-lg q-pb-xl", attrs: { name: "permissions" } },
            [
              _c("div", { staticClass: "row gutter-sm" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12" },
                  [
                    _c("p", { staticClass: "caption" }, [
                      _vm._v(_vm._s(_vm.$t("areas")))
                    ]),
                    _c("q-checkbox", {
                      staticClass: "q-mb-sm",
                      attrs: {
                        disable: !_vm.manage_trails,
                        val: true,
                        label: _vm.$t("select_all_areas")
                      },
                      on: {
                        input: function($event) {
                          return _vm.checkAllAreas()
                        }
                      },
                      model: {
                        value: _vm.all_areas,
                        callback: function($$v) {
                          _vm.all_areas = $$v
                        },
                        expression: "all_areas"
                      }
                    }),
                    _c("select-multiple", {
                      attrs: {
                        label: "",
                        filters: _vm.area,
                        options: _vm.areas,
                        error: _vm.$v.area.$error,
                        input: _vm.changeAreas,
                        disable: !_vm.manage_trails
                      },
                      on: {
                        on_value: function($event) {
                          _vm.area = $event
                        }
                      }
                    })
                  ],
                  1
                ),
                _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
                  _c("p", { staticClass: "caption" }, [
                    _vm._v(_vm._s(_vm.$t("profiles")))
                  ]),
                  _c(
                    "div",
                    { staticClass: "row gutter-sm" },
                    [
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-12" },
                        [
                          _c("q-checkbox", {
                            attrs: {
                              val: true,
                              label: _vm.$t("all"),
                              disable: !_vm.manage_trails
                            },
                            on: {
                              input: function($event) {
                                return _vm.checkAll()
                              }
                            },
                            model: {
                              value: _vm.all_profiles,
                              callback: function($$v) {
                                _vm.all_profiles = $$v
                              },
                              expression: "all_profiles"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._l(_vm.profiles, function(item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            ref: "profile",
                            refInFor: true,
                            staticClass: "col-xs-12 col-sm-4",
                            class: _vm.getErrorClass(_vm.$v.profile.$error)
                          },
                          [
                            _c("q-checkbox", {
                              attrs: {
                                "keep-color": "",
                                val: item.value,
                                label: item.label,
                                color: _vm.getErrorColor(_vm.$v.profile.$error),
                                disable: !_vm.manage_trails
                              },
                              on: {
                                input: function($event) {
                                  return _vm.changeProfiles()
                                }
                              },
                              model: {
                                value: _vm.profile,
                                callback: function($$v) {
                                  _vm.profile = $$v
                                },
                                expression: "profile"
                              }
                            })
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                ])
              ]),
              _vm.useTrailSubscription
                ? _c("div", { staticClass: "row gutter-sm q-mt-md" }, [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-12" },
                      [
                        _c("p", { staticClass: "caption" }, [
                          _vm._v(_vm._s(_vm.$t("mandatory_areas")))
                        ]),
                        _c("q-checkbox", {
                          staticClass: "q-mb-sm",
                          attrs: {
                            disable: !_vm.manage_trails,
                            val: true,
                            label: _vm.$t("select_all_areas")
                          },
                          on: {
                            input: function($event) {
                              return _vm.checkAllMandatoryAreas()
                            }
                          },
                          model: {
                            value: _vm.all_mandatory_areas,
                            callback: function($$v) {
                              _vm.all_mandatory_areas = $$v
                            },
                            expression: "all_mandatory_areas"
                          }
                        }),
                        _c("select-multiple", {
                          attrs: {
                            label: "",
                            filters: _vm.mandatory_areas,
                            options: _vm.mandatoryAreas,
                            error: _vm.$v.mandatory_areas.$error,
                            input: _vm.$v.mandatory_areas.$touch,
                            disable: !_vm.manage_trails
                          },
                          on: {
                            on_value: function($event) {
                              _vm.mandatory_areas = $event
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
                      _c("p", { staticClass: "caption" }, [
                        _vm._v(_vm._s(_vm.$t("mandatory_profiles")))
                      ]),
                      _c(
                        "div",
                        { staticClass: "row gutter-sm" },
                        [
                          _c(
                            "div",
                            { staticClass: "col-xs-12 col-sm-12" },
                            [
                              _c("q-checkbox", {
                                attrs: {
                                  val: true,
                                  label: _vm.$t("all"),
                                  disable: !_vm.manage_trails
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.checkAllMandatoryProfiles()
                                  }
                                },
                                model: {
                                  value: _vm.all_mandatory_profiles,
                                  callback: function($$v) {
                                    _vm.all_mandatory_profiles = $$v
                                  },
                                  expression: "all_mandatory_profiles"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._l(_vm.mandatoryProfiles, function(item, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "col-xs-12 col-sm-4" },
                              [
                                _c("q-checkbox", {
                                  ref: "mandatory_profiles",
                                  refInFor: true,
                                  attrs: {
                                    "keep-color": "",
                                    val: item.value,
                                    label: item.label,
                                    error: _vm.$v.mandatory_profiles.$error,
                                    disable: !_vm.manage_trails
                                  },
                                  on: {
                                    input: _vm.$v.mandatory_profiles.$touch
                                  },
                                  model: {
                                    value: _vm.mandatory_profiles,
                                    callback: function($$v) {
                                      _vm.mandatory_profiles = $$v
                                    },
                                    expression: "mandatory_profiles"
                                  }
                                })
                              ],
                              1
                            )
                          })
                        ],
                        2
                      )
                    ])
                  ])
                : _vm._e(),
              _c("div", { staticClass: "row gutter-sm" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12" },
                  [
                    _c("q-select", {
                      ref: "user_group",
                      attrs: {
                        options: _vm.user_groups,
                        "float-label": _vm.$t("groups"),
                        error: _vm.$v.user_group.$error,
                        multiple: "",
                        chips: "",
                        disable: !_vm.manage_trails
                      },
                      on: { input: _vm.$v.user_group.$touch },
                      model: {
                        value: _vm.user_group,
                        callback: function($$v) {
                          _vm.user_group = $$v
                        },
                        expression: "user_group"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm.id_trail != 0
                ? _c("div", { staticClass: "row gutter-sm q-my-sm" }, [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-11" },
                      [
                        _c("q-input", {
                          attrs: {
                            "float-label": _vm.$t("link"),
                            disable: true
                          },
                          model: {
                            value: _vm.url_trail_portal,
                            callback: function($$v) {
                              _vm.url_trail_portal = $$v
                            },
                            expression: "url_trail_portal"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-1 q-mt-lg" },
                      [
                        _c(
                          "q-btn",
                          {
                            staticClass: "full-width",
                            attrs: {
                              dense: "",
                              color: "primary",
                              icon: "fal fa-copy"
                            },
                            on: {
                              click: function($event) {
                                return _vm.copyLink()
                              }
                            }
                          },
                          [
                            _c("q-tooltip", [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" +
                                  _vm._s(_vm.$t("copy_link")) +
                                  "\n\t\t\t\t\t\t"
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ]
          )
        ],
        1
      ),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("cancel") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "tertiary",
                label: _vm.$t("back"),
                icon: "far fa-chevron-left"
              },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "admin_trails" })
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("save") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "secondary",
                label: _vm.$t("save"),
                icon: "far fa-save",
                disable: !_vm.manage_trails
              },
              on: {
                click: function($event) {
                  return _vm.saveData()
                }
              }
            })
          ],
          1
        )
      ]),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            }
          },
          on: {
            hide: function($event) {
              _vm.filter_parent_trail = ""
            }
          },
          model: {
            value: _vm.show_add_trail_parent,
            callback: function($$v) {
              _vm.show_add_trail_parent = $$v
            },
            expression: "show_add_trail_parent"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_add_trail_parent = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n\t\t\t\t\t" + _vm._s(_vm.$t("trails")) + "\n\t\t\t\t"
                    )
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "layout-padding" },
                [
                  _c("q-table", {
                    attrs: {
                      data: _vm.filteredParentTrails,
                      columns: _vm.columns,
                      pagination: _vm.parent_pagination,
                      "row-key": "content_id",
                      "no-data-label": _vm.$t("no_data_avaliable"),
                      "no-results-label": _vm.$t("no_results_found"),
                      "loading-label": _vm.$t("loading_data"),
                      "rows-per-page-label": _vm.$t("items_per_page"),
                      "rows-per-page-options": [0],
                      "binary-state-sort": ""
                    },
                    on: { request: _vm.fetchTrailParents },
                    scopedSlots: _vm._u([
                      {
                        key: "top",
                        fn: function(props) {
                          return [
                            _c("q-search", {
                              staticClass: "q-mr-lg",
                              attrs: {
                                icon: "far fa-search",
                                placeholder: _vm.$t("search"),
                                "float-label": _vm.$t("search"),
                                debounce: 300
                              },
                              model: {
                                value: _vm.filter_parent_trail,
                                callback: function($$v) {
                                  _vm.filter_parent_trail = $$v
                                },
                                expression: "filter_parent_trail"
                              }
                            }),
                            _c("div", { staticClass: "col" })
                          ]
                        }
                      },
                      {
                        key: "header",
                        fn: function(props) {
                          return _c(
                            "q-tr",
                            { attrs: { props: props } },
                            _vm._l(props.cols, function(col) {
                              return _c(
                                "q-th",
                                { key: col.name, attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(_vm.$t(col.label)) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        }
                      },
                      {
                        key: "body",
                        fn: function(props) {
                          return _c(
                            "q-tr",
                            { attrs: { props: props } },
                            [
                              _c(
                                "q-td",
                                {
                                  key: "content_id",
                                  attrs: { props: props, "auto-width": "" }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(props.row.value) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                {
                                  key: "content_label",
                                  attrs: { props: props, "auto-width": "" }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(props.row.label) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                {
                                  key: "actions",
                                  attrs: { props: props, "auto-width": "" }
                                },
                                [
                                  _c("q-btn", {
                                    attrs: {
                                      color: "secondary",
                                      icon: "far fa-hand-pointer",
                                      label: _vm.$t("select"),
                                      disable: !_vm.manage_trails
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.selectParentTrail(
                                          props.row.value
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }